"use strict";

exports.__esModule = true;
exports.default = void 0;
var _default = {
  "type": "string",
  "enum": ["tk0", "tk1", "tk2", "tk3"],
  "enumNames": ["TK0: Ingen tiltak", "TK1: Vedlikehold/forebyggende konservering", "TK2: Moderate reparasjoner og/eller ytterligere undersøkelse", "TK3: Store inngrep basert på diagnose"],
  "default": "tk0"
};
exports.default = _default;
module.exports = exports.default;